import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'apparel_discovery-showroom_v2-view';
/**
 * view event for showroom v2
 */ export function trackApparelDiscoveryShowroomV2View(customParameterToken, customParameterToken2, customParameterToken3) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            customParameterToken: customParameterToken,
            customParameterToken2: customParameterToken2,
            customParameterToken3: customParameterToken3
        }
    });
}
